
<kendo-grid #manageAddressGrid [data]="manageAddressGridView"
            [height]="470"
            [sortable]="true"
            [navigable]="true"
            [filterable]="true"
            [groupable]="false"
            [reorderable]="true"
            [resizable]="false"
            [sort]="state.sort"
            (sortChange)="manageAddressGridSortChange($event)"
            [pageable]="{ buttonCount: 5, info: true }"
            [pageSize]="state.take"
            [skip]="state.skip"
            [columnMenu]="false"
            (pageChange)="manageAddressGridPageChange($event)"
            (dataStateChange)="manageAddressDataStateChange($event)"
            [filter]="state.filter"
            [loading]="gridSettings.gridLoading">
  <ng-template [ngIf]="showAddAddressBtn">
    <ng-template kendoGridToolbarTemplate>
      <button kendoButton class="buttonSize addShippingBtn" *ngIf="showAddAddressBtn" type="button"
              (click)="addShippingDialogOpen()">
        <span class="k-icon k-i-plus-outline"></span> &nbsp; {{lblText.addAddressLbl?lblText.addAddressLbl:manageAddress.addAddressLbl}}
      </button>
    </ng-template>
  </ng-template>
  <kendo-grid-column field="customerNumber" title="{{lblText.customerNumberLbl?lblText.customerNumberLbl:manageAddress.customerNumberLbl}}" [columnMenu]="false" [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="mailingName" title="{{lblText.nameLbl?lblText.nameLbl:manageAddress.nameLbl}}" [columnMenu]="false" [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="addressLine1" title="{{lblText.addressLine1Lbl?lblText.addressLine1Lbl:manageAddress.addressLine1Lbl}}" [columnMenu]="false" [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="addressLine2" title="{{lblText.addressLine2Lbl?lblText.addressLine2Lbl:manageAddress.addressLine2Lbl}}" [columnMenu]="false" [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="city" title="{{lblText.cityLbl?lblText.cityLbl:manageAddress.cityLbl}}" [columnMenu]="false" [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="state" title="{{lblText.stateLbl?lblText.stateLbl:manageAddress.stateLbl}}" [columnMenu]="false" [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="zipCode" title="{{lblText.zipcodeLbl?lblText.zipcodeLbl:manageAddress.zipcodeLbl}}" [columnMenu]="false" [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="country" title="{{lblText.countryLbl?lblText.countryLbl:manageAddress.countryLbl}}" [columnMenu]="false" [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="phoneNumber" title="{{lblText.phoneNumberLbl?lblText.phoneNumberLbl:manageAddress.phoneNumberLbl}}" [columnMenu]="false" [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column title="{{lblText.archiveLbl?lblText.archiveLbl:manageAddress.archiveLbl}}" field="">
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-switch (ngModelChange)="archiveUnarchiveAddress(dataItem, $event)" [hidden]="dataItem?.billingType==='B' || dataItem?.billingType==='X'"
                    [ngModel]="!dataItem.isActive" [onLabel]="'Yes'"
                    [offLabel]="'No'">
      </kendo-switch>
      <kendo-loader *ngIf="dataItem.updateInProgress" style="color:blue"></kendo-loader>
    </ng-template>
  </kendo-grid-command-column>
  <kendo-grid-command-column title="{{lblText.isDefaultLbl?lblText.isDefaultLbl:manageAddress.isDefaultLbl}}" field="">
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-switch (ngModelChange)="isDefaultAddress(dataItem, $event)" [disabled]="!dataItem?.isActive" [hidden]="dataItem?.billingType==='B'"
                    [(ngModel)]="dataItem.isDefault" [onLabel]="'Yes'"
                    [offLabel]="'No'">
      </kendo-switch>
      <kendo-loader *ngIf="dataItem.isDefaultUpdateInProgress" style="color:blue"></kendo-loader>
    </ng-template>
  </kendo-grid-command-column>


  <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
    <kendo-pager-info></kendo-pager-info>
    <kendo-pager-next-buttons></kendo-pager-next-buttons>
    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
  </ng-template>
</kendo-grid>
<section>
  <kendo-dialog title="{{lblText.shippingAddressLbl?lblText.shippingAddressLbl:manageAddress.shippingAddressLbl}}" *ngIf="addShippingDialog.opened" (close)="addShippingDialogClose()">
    <div class="shippingFormMainDiv">
      <form [formGroup]="addShippingForm">
        <div class="row" style="min-height:25px;">
          <div class="col-sm-12">
            <ul style="margin-bottom:0px; padding-left:15px;" *ngIf="showValidationInfo"><li style="color:red;"><span>{{inputValidationMessage}}</span></li></ul>
          </div>
        </div>
        <div class="row">

          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">{{lblText.nameLbl?lblText.nameLbl:manageAddress.nameLbl}}<span class="requiredField">*</span></label>
              <kendo-textbox appInputValidator (showInfo)="showInfo($event)"
                             class="form-control"
                             name="customerName"
                             formControlName="customerName"
                             (blur)="validateAddShippingForm()"
                             [ngClass]="{'borderRed':addShippingDialog.isInvalidCustomerName && addShippingDialog.isSubmitted}"
                             [clearButton]="false" [maxlength]="40" tabindex="1"></kendo-textbox>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.addressLine1Lbl?lblText.addressLine1Lbl:manageAddress.addressLine1Lbl}}<span class="requiredField">*</span>
              </label>
              <kendo-textbox appInputValidator (showInfo)="showInfo($event)"
                             class="form-control"
                             name="addressLine1"
                             formControlName="addressLine1"
                             (blur)="validateAddShippingForm()"
                             [ngClass]="{'borderRed':addShippingDialog.isInvalidAddressLine1 && addShippingDialog.isSubmitted}"
                             [clearButton]="false" [maxlength]="40" tabindex="2"></kendo-textbox>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.addressLine2Lbl?lblText.addressLine2Lbl:manageAddress.addressLine2Lbl}}
              </label>
              <kendo-textbox appInputValidator (showInfo)="showInfo($event)"
                             class="form-control"
                             name="addressLine2"
                             formControlName="addressLine2"
                             [clearButton]="false" [maxlength]="40" tabindex="3"></kendo-textbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.cityLbl?lblText.cityLbl:manageAddress.cityLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-textbox appInputValidator (showInfo)="showInfo($event)"
                             class="form-control"
                             name="city"
                             formControlName="city"
                             (blur)="validateAddShippingForm()"
                             [ngClass]="{'borderRed':addShippingDialog.isInvalidCity && addShippingDialog.isSubmitted}"
                             [clearButton]="false" [maxlength]="25" tabindex="4"></kendo-textbox>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.countryLbl?lblText.countryLbl:manageAddress.countryLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-dropdownlist kendoTextBox [data]="addShippingDialog.countries" class="kendoInput"
                                  [textField]="'countryName'"
                                  [valueField]="'countryCode'"
                                  name="country"
                                  formControlName="country"
                                  (blur)="validateAddShippingForm()"
                                  (selectionChange)="addShippingDialogCountySelectionChange($event)"
                                  [ngClass]="{'borderRed':addShippingDialog.isInvalidCountry && addShippingDialog.isSubmitted}"
                                  [valuePrimitive]="true"
                                  tabindex="5">
              </kendo-dropdownlist>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.stateLbl?lblText.stateLbl:manageAddress.stateLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-dropdownlist kendoTextBox [data]="addShippingDialog.states"
                                  class="kendoInput kdropdownlistAddShipping"
                                  [textField]="'stateDescription'"
                                  [valueField]="'stateCode'"
                                  name="state"
                                  formControlName="state"
                                  (blur)="validateAddShippingForm()"
                                  (selectionChange)="addShippingDialogStateSelectionChange($event)"
                                  [ngClass]="{'borderRed':addShippingDialog.isInvalidState && addShippingDialog.isSubmitted}"
                                  [valuePrimitive]="true" tabindex="6">
              </kendo-dropdownlist>

            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.zipcodeLbl?lblText.zipcodeLbl:manageAddress.zipcodeLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-textbox appInputValidator (showInfo)="showInfo($event)"
                             class="form-control"
                             name="zipCode"
                             formControlName="zipCode"
                             (blur)="validateAddShippingForm(); statusCheck();"
                             [ngClass]="{'borderRed':addShippingDialog.isInvalidZipCode && addShippingDialog.isSubmitted}"
                             [clearButton]="false" maxlength="10" tabindex="7"></kendo-textbox>
              <!-- <span title="Zip code length should be minimum 10" *ngIf="addShippingForm.controls['zipCode'].hasError('minlength')" kendoTooltip class="k-icon k-i-information k-i-info spanInfoIconCls"></span> -->
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.countyLbl?lblText.countyLbl:manageAddress.countyLbl}}
              </label>
              <kendo-textbox appInputValidator (showInfo)="showInfo($event)"
                             class="form-control"
                             name="county"
                             formControlName="county"
                             tabindex="8"></kendo-textbox>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.phoneNumberLbl?lblText.phoneNumberLbl:manageAddress.phoneNumberLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-numerictextbox class="kendoInput"
                                    name="phoneNumber"
                                    formControlName="phoneNumber"
                                    [decimals]="0"
                                    [format]="'#'"
                                    [spinners]="false"
                                    (blur)="validateAddShippingForm()"
                                    [ngClass]="{'borderRed':addShippingDialog.isInvalidPhoneNumber && addShippingDialog.isSubmitted}"
                                    maxlength="10" tabindex="9"></kendo-numerictextbox>
              <span title="{{lblText.phoneValidationLbl?lblText.phoneValidationLbl:manageAddress.phoneValidationLbl}}"
                    *ngIf="addShippingDialog.isInvalidPhoneNumberMessage" kendoTooltip class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            </div>
          </div>
        </div>

        <div *ngIf="duplicateAddressList?.length>0">
          <span>{{lblText.duplicateAddressText1?lblText.duplicateAddressText1:manageAddress.duplicateAddressText1}} <b>{{lblText.zipcodeLbl?lblText.zipcodeLbl:manageAddress.zipcodeLbl}}</b> {{lblText.duplicateAddressText2?lblText.duplicateAddressText2:manageAddress.duplicateAddressText2}} <b>{{lblText.addNewAddressLbl?lblText.addNewAddressLbl:manageAddress.addNewAddressLbl}}</b>{{lblText.duplicateAddressText3?lblText.duplicateAddressText3:manageAddress.duplicateAddressText3}}</span>
          <div class="row">
            <kendo-grid [data]="duplicateAddressList" class="my-custom-grid"
                        [pageSize]="pageSize"
                        [skip]="skip"
                        [pageable]="true"
                        (pageChange)="pageChange($event)"
                        [selectable]="true"
                        scrollable="virtual"
                        [rowHeight]="36"
                        [height]="200">
              <kendo-grid-column media="(max-width: 1049px)" title="Matching Addresses">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="row">
                    <div style="width:100%">
                      <div class="row" style="width:100%">
                        <div class="col-12 title-bold">
                          <!--bold-->
                          {{dataItem.customerNumber}}
                        </div>
                      </div>
                      <div class="row" style="width:100%">
                        <div class="col-12 paddingZero">
                          {{dataItem.addressLine1}}
                        </div>
                      </div>
                      <div class="row" style="width:100%">
                        <div class="col-12 paddingZero">
                          {{dataItem.addressLine2}}
                        </div>
                      </div>

                      <div class="row" style="width:100%">
                        <div class="col-6 col-md-3 paddingZero">
                          <span class="txt-bold">{{lblText.cityLbl?lblText.cityLbl:manageAddress.cityLbl}}</span> : {{dataItem.city}}
                        </div>

                        <div class="col-6 col-md-3 paddingZero">
                          <span class="txt-bold">{{lblText.stateLbl?lblText.stateLbl:manageAddress.stateLbl}}</span>: {{dataItem.state}}
                        </div>
                        <div class="col-6 col-md-3 paddingZero">
                          <span class="txt-bold">{{lblText.zipcodeLbl?lblText.zipcodeLbl:manageAddress.zipcodeLbl}}</span> :  {{dataItem.zipCode}}
                        </div>

                        <div class="col-6 col-md-3 paddingZero">
                          <span class="txt-bold">{{lblText.countryLbl?lblText.countryLbl:manageAddress.countryLbl}}</span>: {{dataItem.country}}
                        </div>
                        <div class="col-6 col-md-3 paddingZero">
                          <button kendoButton (click)="selectExistingShippingAddress(dataItem)"
                                  class="btn-small btn btn-success">
                            {{lblText.selectLbl?lblText.selectLbl:manageAddress.selectLbl}}
                          </button>
                        </div>

                      </div>

                    </div>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="selectonSwitch" title="{{lblText.selectAddressLbl?lblText.selectAddressLbl:manageAddress.selectAddressLbl}}" [width]="100" [filterable]="false">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <button kendoButton (click)="selectExistingShippingAddress($event,dataItem)"
                          class="btn-small btn btn-success my-select-btn">
                    {{lblText.selectLbl?lblText.selectLbl:manageAddress.selectLbl}}
                  </button>

                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="customerNumber" title="{{lblText.customerNumberLbl?lblText.customerNumberLbl:manageAddress?.customerNumberLbl}}" [filterable]="true">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                    <kendo-filter-contains-operator></kendo-filter-contains-operator>
                  </kendo-grid-string-filter-cell>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="addressLine1"
                                 title="Address Line 1"></kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="addressLine2"
                                 title="Address Line 2"></kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="city"
                                 title="City"></kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="state"
                                 title="State"></kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="zipCode"
                                 title="Zip Code"></kendo-grid-column>
            </kendo-grid>

          </div>

        </div>

        <div class="dialog-btn-section">
          <div class="row">
            <div class="col-sm-12 float-left">
              <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 btn-align-center">
              <div class="btn-group" role="group">
                <button kendoButton (click)="addShippingDialogClose()" [disabled]=" saveInProcess" class=" m-3 btn k-button dialogBtnSize">{{lblText.closeLbl?lblText.closeLbl:manageAddress.closeLbl}}</button> &nbsp;&nbsp;
                <button kendoButton (click)="addNewShippingHandler($event,addShippingForm.value)" [disabled]="isDisabled" class=" m-3 btn btn-success dialogBtnSize">{{lblText.saveLbl?lblText.saveLbl:manageAddress.saveLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader> </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </kendo-dialog>
</section>
<kendo-dialog *ngIf="showLastAddressPopup"
              title="Warning"
              (close)="closeLastAddressPopup()">

  <div><b>
    You are attempting to archive the last available shipping address.
    At least one shipping address must be available for shipping selection
    during checkout and remain unarchived.
  </b></div>

  <kendo-dialog-actions>
    <button kendoButton (click)="closeLastAddressPopup()">
      Close
    </button>
  </kendo-dialog-actions>

</kendo-dialog>
